import * as React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import Button from "@mui/material/Button";
import { CSVLink } from "react-csv";
import CSVUploder from "./CSVUploder";
import Table from "../../../../component-lib/Organisms/table/EventEHRTable";

const steps = [
  {
    label: "Download Sample CSV File",
  },
  {
    label:
      "Prefer This As An Example For Add or Edit Entity Info In CSV Template",
  },
  {
    label: "Upload CSV File",
  },
];

interface StepperForDataImportProps {
  onFileUpload: (file: File) => void;
  selectedFile?: any;
  setSelectedFile?: any;
  handleFileRemoveCb?: any;
}

export default function StepperForDataImport({
  onFileUpload,
  handleFileRemoveCb,
}: StepperForDataImportProps) {
  const EMPTY_CSV_DATA: any[] = [];
  const CSV_HEADERS_PATIENT_REPORTS = [
    { label: "Type", key: "type" },
    { label: "Code", key: "code" },
    { label: "Description", key: "description" },
    // { label: "Status", key: "status" },
  ];

  const columns = [
    // {
    //   field: "A",
    //   label: <div>A</div>,
    //   renderLogic: (row: any) => row?.id,
    // },
    {
      field: "A",
      label: <div>Type</div>,
      renderLogic: (row: any) => row?.type,
    },
    {
      field: "B",
      label: <div>Code</div>,
      renderLogic: (row: any) => row?.code,
    },
    {
      field: "C",
      label: <div>Description</div>,
      renderLogic: (row: any) => row?.description,
    },
    // {
    //   field: "D",
    //   label: <div>D</div>,
    //   renderLogic: (row: any) => row?.status,
    // },
  ];

  const sampleData = [
    {
      // id: "id",
      type: "Type Should Be ICD10 Or DSM",
      code: "Enter Your Code Here ",
      description: "Enter Your Description Here",
      // status: "status",
    },
  ];
  const [activeStep, setActiveStep] = React.useState(0);
  const [isFileUploaded, setIsFileUploaded] = React.useState(false);
  const [selectedFile, setSelectedFile] = React.useState<File | null>(null);

  const handleNext = () => {
    if (activeStep < steps.length - 1) {
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
    }
  };

  const handleBack = () => {
    if (activeStep > 0) {
      setActiveStep((prevActiveStep) => prevActiveStep - 1);
    }
  };

  const handleStepClick = (stepIndex: number) => {
    setActiveStep(stepIndex);
  };

  const handleFileRemove = () => {
    setIsFileUploaded(false);
    setSelectedFile(null);
    handleFileRemoveCb();
  };

  const handleFileUploadClick = (file: File) => {
    setIsFileUploaded(true);
    onFileUpload(file);
  };

  return (
    <Box sx={{ maxWidth: 600 }}>
      <Stepper nonLinear activeStep={activeStep} orientation="vertical">
        {steps.map((step, index) => (
          <Step key={step.label}>
            <StepLabel
              onClick={() => handleStepClick(index)}
              sx={{
                cursor: "pointer",
                fontWeight: activeStep === index ? "bold" : "normal",
              }}
            >
              {step.label}
            </StepLabel>
            <StepContent>
              {/* <Typography>{step.description}</Typography> */}

              {/* Step 1 - Download Empty CSV */}
              {index === 0 && (
                <CSVLink
                  data={EMPTY_CSV_DATA}
                  headers={CSV_HEADERS_PATIENT_REPORTS}
                  //filename={"empty-patient-reports.csv"}
                  style={{ textDecoration: "none" }}
                >
                  <Button variant="contained" sx={{ mt: 1, mb: 2 }}>
                    Download Sample CSV
                  </Button>
                </CSVLink>
              )}
              {index === 1 && (
                <Table
                  columns={columns}
                  rows={sampleData}
                  style={{ width: "600px" }}
                />
              )}

              {/* Step 3 - Upload CSV File */}
              {index === 2 && (
                <CSVUploder
                  onFileUpload={handleFileUploadClick}
                  onFileRemove={handleFileRemove}
                  setSelectedFile={setSelectedFile}
                  selectedFile={selectedFile}
                />
              )}
              <Box sx={{ mb: 2 }}>
                {/* Show Continue button only if it's not the last step */}
                {index < steps.length - 1 && !isFileUploaded && (
                  <Button
                    variant="contained"
                    onClick={handleNext}
                    sx={{ mt: 1, mr: 1 }}
                  >
                    Next
                  </Button>
                )}

                {/* Show Back button on all steps except the first */}
                {index > 0 && (
                  <Button onClick={handleBack} sx={{ mt: 1, mr: 1 }}>
                    Back
                  </Button>
                )}
              </Box>
            </StepContent>
          </Step>
        ))}
      </Stepper>

      {/* Display that file is uploaded
      {isFileUploaded && (
        <Typography variant="body2">File uploaded successfully!</Typography>
      )} */}
    </Box>
  );
}
